var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"botton",on:{"click":_vm.encryption}},[_vm._v("去支付")])}
var staticRenderFns = []

export { render, staticRenderFns }